import React from 'react';
import {Icon} from 'components';
import {modal} from 'helpers';
import css from './video.module.scss';

export function Video({ src, popup }) {
  return Boolean(src) && (
    <div className={css('container', { insidePopup: Boolean(popup) })}>
      { /embed/.test(src)
        ? <iframe src={`${src}?rel=0`} />
        : <video controls preload="metadata" autoPlay muted>
          <source src={src} type="video/mp4" />
        </video>
      }
      { popup &&
        <Icon name="close" className={css.close} onClick={popup.close} />
      }
    </div>
  );
}

export function Trigger({ src }) {
  return Boolean(src) && (
    <Icon name="play-alt" onClick={modal(Video, { src, className: css.modal })} />
  );
}
